import { FormBuilderContainer } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { TExtends } from '../../infrastructure/internationalisation'
import { ActionBar } from '../organisms/form'
import { FormErrorsPortal, FormFooter, FormItems } from './components'
import { useDataWithDefaultValues } from './defaultValues'
import { ERROR_MESSAGE_CLASS } from './options'
import { FormBuilderProps } from './types'

export const FormErrors: FunctionComponent<FormBuilderProps> = ({
  id,
  footerText,
  data,
  config,
  onSubmit,
  onSkip,
  loading,
  options = {},
  tKey,
  t,
  ...props
}) => {
  const form = useForm({
    values: useDataWithDefaultValues(config, data),
  })

  return (
    <FormProvider {...form}>
      <FormBuilderContainer
        data-testid={id}
        onSubmit={form.handleSubmit(onSubmit)}
        width={1}
        {...props}
      >
        <FormItems
          config={config}
          options={options}
          errorClassName={ERROR_MESSAGE_CLASS}
          tKey={TExtends(tKey, 'inputs')}
          t={t}
        />
        <FormFooter tKey={tKey} tName={footerText} t={t} />
        <ActionBar tKey={tKey} loading={loading} onDismiss={onSkip} />
      </FormBuilderContainer>
      <FormErrorsPortal tKey={tKey} t={t} errorClass={ERROR_MESSAGE_CLASS} />
    </FormProvider>
  )
}
